import { render, staticRenderFns } from "./ProgressWizard.vue?vue&type=template&id=28197d0a&scoped=true"
import script from "./ProgressWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressWizard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProgressWizard.vue?vue&type=style&index=0&id=28197d0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28197d0a",
  null
  
)

export default component.exports